<div class="row">
  <div class="col s12 m6">
    <h4 class="card-title">Cache Refresh</h4>
  </div>
  <div class="col s12 m6 right-align">
  </div>
</div>
<div class="row" style="height: 400px;">
  <div class="col s12 m4">
    <input [(ngModel)]="selectedMoment" [owlDateTime]="dt1" [selectMode]="'range'" [owlDateTimeTrigger]="dt1"
      placeholder="Date Time" style="width: 300px;">
    <span class="trigger" [owlDateTimeTrigger]="dt1">
      <i class="material-icons tatt-i-btn">date_range</i>
    </span>
    <owl-date-time [pickerType]="'calendar'" #dt1></owl-date-time>
  </div>

  <div class="col s12 m2 left-align">
    <a class="dropdown-trigger btn waves-effect waves-light btn gradient-45deg-green-teal z-depth-4 mb-2" data-target="ddl_cache_refresh" style="min-width:158px; margin-top: 3px;">
      <i class="material-icons right" style="opacity:0.7;">keyboard_arrow_down</i>
      <span *ngIf="cachetype">{{cachetype}}</span>
    </a>
    <ul id="ddl_cache_refresh" class="dropdown-content">
      <li (click)="cacheSelect(rec.cacheType)" *ngFor="let rec of pageData.cacheType; let iRec = index;">
        <a class="li_cachetype">{{rec.cacheType}}</a>
      </li>
    </ul>
  </div>

  <div class="col s12 m4 left-align">
    <a class='dropdown-trigger btn waves-effect waves-light btn gradient-45deg-green-teal z-depth-4 mb-2' href='#' data-target='ddl_dashboard_areas' style="min-width:158px; margin-top: 3px;">
      <i class="material-icons right" style="opacity:0.7;">keyboard_arrow_down</i>
      <span *ngIf="!area">Loading..</span>
      <span *ngIf="area">{{area.areaName}}</span>
    </a>
    <!-- Dropdown Structure -->
    <ul id='ddl_dashboard_areas' class='dropdown-content'>
      <li (click)="areaSelect(rec)" *ngFor="let rec of pageData.areas; let iRec = index;">
        <a href="javascript:void(0);" class="li_area">{{rec.areaName}}</a>
      </li>
    </ul>
    <i (click)="pageData.autoRefresh = !pageData.autoRefresh" class="material-icons tatt-i-btn hide" [ngClass]="{'icon-light-blue': pageData.autoRefresh}">refresh</i>
  </div>

  <div class="col s12 m2 right-left">
    <a (click)="Submit()"  class="waves-effect waves-light gradient-45deg-green-teal btn ml-1"
      style="min-width: 158px;">
      Submit
    </a>
  </div>
</div>
<div>